import { useEffect } from 'react';
import Lenis from 'lenis';
import { OrderProvider } from '@/context/OrderContext';
import { setLenis } from '@/lib/scroll';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import Marquee from '@/components/Marquee';
import { WhySection } from '@/components/EvidenceSections';
import ZonesSection from '@/components/ZonesSection';
import MechanicsSection from '@/components/MechanicsSection';
import PackagesSection from '@/components/PackagesSection';
import CampaignsSection from '@/components/CampaignsSection';
import ExtrasSection from '@/components/ExtrasSection';
import ComparisonSection from '@/components/ComparisonSection';
import ProcessSection from '@/components/ProcessSection';
import OrderForm from '@/components/OrderForm';
import Footer from '@/components/Footer';

export default function Landing() {
  useEffect(() => {
    document.title = 'Instore Media · GLOBUS Markthalle Koblenz';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return undefined;
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <OrderProvider>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <WhySection />
        <ZonesSection />
        <MechanicsSection />
        <PackagesSection />
        <CampaignsSection />
        <ExtrasSection />
        <ComparisonSection />
        <ProcessSection />
        <OrderForm />
      </main>
      <Footer />
    </OrderProvider>
  );
}
